module.exports = __webpack_public_path__ + "static/img/GooglePlay-icon.1423f8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/GooglePlay-icon.svg
// module id = 1145
// module chunks = 1